// extracted by mini-css-extract-plugin
export default {"header":"Form_header__STc79","text":"Form_text__5xJEE","phone":"Form_phone__RDD7g","link":"Form_link__6NHit"};